import React from 'react'
import BRDCampaignBuilder from './creative-matrix/BRDCampaignBuilder'

// BRD-driven Creative Matrix System
interface CampaignBuilderCompleteProps {
  initialAssets?: any[]
  brdRules?: any[]
  traffickingHeaders?: string[]
  loadingAssets?: boolean
  onBRDUpload?: (rules: any[]) => void
  onTraffickingUpload?: (headers: string[]) => void
  onAssetAdd?: (asset: any) => void
  campaignName?: string
  campaignDescription?: string
}

export default function CampaignBuilderComplete(props: CampaignBuilderCompleteProps) {
  console.log('[CampaignBuilderComplete] Received props:', {
    initialAssets: props.initialAssets?.length,
    brdRules: props.brdRules?.length,
    traffickingHeaders: props.traffickingHeaders?.length,
    loadingAssets: props.loadingAssets
  })
  
  return <BRDCampaignBuilder {...props} />
}
